import { Directive, ElementRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[formControlName][cepMask]',
})
export class CepMaskDirective implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(
    private el: ElementRef,
    private cepControl: NgControl,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.subscribeMudancasNoCep();
  }

  ngOnDestroy() {
    this.unsubscribeMudancasNoCep();
  }

  private subscribeMudancasNoCep() {
    this.subscription = this.cepControl.control.valueChanges.subscribe((novoValor) => {
      if (!novoValor || typeof novoValor !== 'string') {
        return;
      }

      let valorAtual = novoValor.replace(/\D/g, '');
      const selecaoAtual = this.el.nativeElement.selectionStart;
      const selecaoFinal = this.el.nativeElement.selectionEnd;
      let novaPosicaoCursor = selecaoAtual;

      if (valorAtual.length <= 5) {
        valorAtual = valorAtual.replace(/^(\d{0,5})/, '$1');
        if (novaPosicaoCursor === 5) {
          novaPosicaoCursor--;
        }
      } else if (valorAtual.length <= 8) {
        valorAtual = valorAtual.replace(/^(\d{0,5})(\d{0,3})/, '$1-$2');
        if (novaPosicaoCursor === 7) {
          novaPosicaoCursor--;
        }
      }

      const diff = valorAtual.length - novoValor.length;
      novaPosicaoCursor = selecaoAtual + diff;

      const removedChar = valorAtual.charAt(selecaoAtual);

      if (removedChar === '-' && novaPosicaoCursor !== 5) {
        this.updateFormControlAndSelection(valorAtual, selecaoAtual, selecaoFinal);
      } else if (removedChar === ' ') {
        this.updateFormControlAndSelection(valorAtual, selecaoAtual, selecaoFinal);
      } else if (novaPosicaoCursor === -1) {
        novaPosicaoCursor = 0;
        this.updateFormControlAndSelection(valorAtual, novaPosicaoCursor, novaPosicaoCursor);
      } else {
        this.updateFormControlAndSelection(valorAtual, novaPosicaoCursor, novaPosicaoCursor);
      }
    });
  }

  private unsubscribeMudancasNoCep() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateFormControlAndSelection(value: string, start: number, end: number) {
    this.cepControl.control.setValue(value.replace(/\D/g, ''), { emitEvent: false });
    this.el.nativeElement.value = value;
    this.renderer.selectRootElement(this.el).nativeElement.setSelectionRange(start, end);
  }
}
